/* eslint-disable react/no-danger */
import type { GatsbySSR } from 'gatsby';
import React from 'react';

import { GlobalLoaderProvider } from './src/context/GlobalLoaderContext';
import { BaseLayout } from './src/components/BaseLayout';

// Note providers normall would go in wrap pageElement but we need the location
export const wrapPageElement: GatsbySSR['wrapPageElement'] = ({
  element,
  props,
}) => (
  <GlobalLoaderProvider>
    <BaseLayout {...props}>{element} </BaseLayout>
  </GlobalLoaderProvider>
);

export const onRenderBody: GatsbySSR['onRenderBody'] = ({
  setHeadComponents,
}) => {
  setHeadComponents([
    <script
      key="partytown-vanilla-config"
      dangerouslySetInnerHTML={{
        __html: `partytown = { debug: false }`,
      }}
    />,
  ]);
};
